import { render, staticRenderFns } from "./form-action.vue?vue&type=template&id=03f2118c&scoped=true&"
import script from "./form-action.vue?vue&type=script&lang=js&"
export * from "./form-action.vue?vue&type=script&lang=js&"
import style0 from "./form-action.vue?vue&type=style&index=0&id=03f2118c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f2118c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
